<template>
  <div class="search-results">
    <!-- SEARCH INPUT -->
    <div class="search-input">
      <search-autocomplete
        :displayIcon="true"
        :displaySearchButton="true"
        :redirectOnSearch="false"
        @search="search"
      ></search-autocomplete>
    </div>

    <!-- TABS -->
    <div class="search-result-tabs" v-if="results && results.length > 0">
      <search-tabs></search-tabs>
    </div>

    <div class="search-result-row">
      <!-- LEFT SIDE COLUMN -->
      <div class="search-result-col-left">
        <!-- QUICK LINKS -->
        <div class="search-quick-link" v-if="results && results.length > 0">
          <search-quick-link></search-quick-link>
        </div>
        <!-- FILTER ON DESKTOP -->
        <search-filter v-if="results && results.length > 0"></search-filter>
      </div>

      <!-- MAIN COLUMN -->
      <div class="search-result-col-middle">
        <!-- RESULTS OPTIONS -->
        <div class="search-result-options" v-if="results && results.length > 0">
          <search-option></search-option>
        </div>

        <!-- LIST -->
        <div class="search-result-list" v-if="results && results.length > 0">
          <search-item
            :item="r"
            v-bind:key="r.rank"
            v-for="r in results"
          ></search-item>
        </div>

        <!-- PAGINATION -->
        <div
          class="search-result-pagination"
          v-if="results && results.length > 0"
        >
          <search-paginator></search-paginator>
        </div>
      </div>
    </div>

    <div class="search-result-empty" v-if="results && results.length === 0">
      <p>No results... Please try another search.</p>
    </div>
  </div>
</template>

<script>
import SearchAutocomplete from "./searchAutocomplete";
import SearchTabs from "./searchTabs";
import SearchOption from "./searchOption";
import SearchPaginator from "./searchPaginator";
import SearchItem from "./searchItem";
import SearchFilter from "./searchFilter";
import SearchQuickLink from "./searchQuickLink";

import { mapState } from "vuex";

import { removeURLParameter } from "../../helpers";

/*
  Types/Tabs:
    response.facets[{name:"Tabs"}]
  Related search:
    response.resultPacket.contextualNavigation.categories
*/

export default {
  name: "SearchResult",
  components: {
    SearchAutocomplete,
    SearchTabs,
    SearchOption,
    SearchPaginator,
    SearchItem,
    SearchFilter,
    SearchQuickLink,
  },
  computed: {
    ...mapState({
      currentPage: (state) => state.search.options.currentPage,
      selectedTab: (state) => state.search.tabs.selected,
      selectedSort: (state) => state.search.options.selectedSort,
      selectedLimit: (state) => state.search.options.selectedLimit,
      selectedFilters: (state) => state.search.filters.selected,
      results: (state) => state.search.results,
    }),
    searchInput: {
      get() {
        return this.$store.getters.searchInput;
      },
      set(value) {
        this.$store.commit("setSearchInput", value);
      },
    },
  },
  watch: {
    currentPage(newVal, oldVal) {
      this.search();
    },
    selectedTab(newVal, oldVal) {
      this.search();
    },
    selectedSort(newVal, oldVal) {
      this.search();
    },
    selectedLimit(newVal, oldVal) {
      this.search();
    },
    selectedFilters(newVal, oldVal) {
      this.search();
    },
  },
  created() {
    let uri = window.location.search.substring(1);
    if (uri.length > 0) {
      let params = new URLSearchParams(uri);
      const query = params.get("query");
      if (query) {
        this.searchInput = query;
        // Remove the query params from the URL
        let querylessUrl = removeURLParameter("query");
        window.history.pushState({}, document.title, querylessUrl);
      }
    }
  },
  mounted() {
    this.search();
  },

  methods: {
    search() {
      this.$store
        .dispatch("fetchSearchResults")
        .then((response) => {})
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style scoped>
.search-results {
  --contentWidth: 70%;
  padding: 30px 0;
}

.search-results > * {
  margin: auto;
}

.search-input {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: var(--contentWidth);
}

.search-result-row {
  position: relative;
  max-width: var(--contentWidth);
  padding-top: 30px;
}

.search-result-col-left {
  margin: 0 6px 12px;
  position: absolute;
  left: -220px;
}

.search-result-col-middle {
  margin: 0 6px;
}

.search-result-tabs {
  padding-top: 30px;
}

.search-result-list {
  padding-top: 20px;
}

.search-result-pagination {
  padding: 15px 0;
}

.search-item {
  margin-bottom: 15px;
}

.search-result-empty {
  display: flex;
  justify-content: center;
  max-width: var(--contentWidth);
  padding: 25px 0;
}

.search-result-empty p {
  font-size: 18px;
}

.search-quick-link {
  margin-bottom: 16px;
}

@media only screen and (max-width: 1280px) {
  .search-result-row {
    max-width: calc(var(--contentWidth) - 15%);
  }
}

@media only screen and (max-width: 970px) {
  .search-results {
    --contentWidth: 85%;
  }

  .search-result-row {
    max-width: var(--contentWidth);
  }

  .search-result-col-left {
    display: none;
  }

  .search-result-options {
    padding-top: 20px;
  }
}

@media only screen and (max-width: 450px) {
  .search-results {
    --contentWidth: 100%;
    padding-top: 20px;
  }

  .search-result-col-middle {
    margin: 0px 0px;
  }

  .search-result-row,
  .search-result-tabs {
    padding-top: 20px;
  }

  .search-result-options {
    padding-top: 0px;
  }
}
</style>


// WEBPACK FOOTER //
// searchResult.vue?05a35c2c